import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiChevronDown } from 'react-icons/fi'; // Using react-icons library
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { FaFileExcel } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FiChevronUp, } from 'react-icons/fi';
import { User } from 'react-feather'; // Import the User icon
const Circle = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  // margin:14px 44px;
`;
const ProfileIcon = styled.div`
 width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;
const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 3px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
      color:#293495;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1; /* Ensure input takes up remaining space */
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000; /* Adjust color as needed */
`;

const Card = styled.div`
  box-shadow: 0px 5px 10px #00000038;
  background: #fff;
  border-radius: 10px;
  opacity: 1;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 200px;
`;

const DateContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 20px;
  margin-left: 20px;

`;

const DateInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

`;

const Label = styled.label`
  color: #3D46B4;
  margin-bottom: 5px;
`;

const Dropdown = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #3D46B4;
  padding: 10px;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  position: relative;
  background: transparent;
`;

const DropdownText = styled.span`
  color: #293495;
  font-size: 16px;
`;

const DropdownIcon = styled(FiChevronDown)`
  color: #3D46B4;
`;

const DropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 5px); /* Positioning panel just below the dropdown */
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #3D46B4;
  border-radius: 4px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;

const DropdownOption = styled.div`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 20px;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  &:first-child {
    background-color: #FF4B4B;
    box-shadow: 0px 10px 20px #7E18182E;
  }
  &:last-child {
    background-color: #2B3497;
    box-shadow: 0px 10px 20px #2B349752;
  }
`;


const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0px 10px 20px #0000001A;
  border-radius: 6px;
  opacity: 1;
`;



const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
`;

const TableBody = styled.tbody``;



const StyledDatePicker = styled(DatePicker)`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: 'Segoe UI', Regular;
    background: transparent;
    border-bottom: 1px solid #2B3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2B3497;
    }
  }`
const CompanyInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;

const CompanyInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const EmployeeNameInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;

const EmployeeNameInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;

const LocationInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;

const LocationInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const PassReturnInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;
const CustomInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;
const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;
const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
  cursor:pointer;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2b3497;
  margin: 0 5px;
`;
const StyledDropdown = styled.select`
  border: none;
  border-bottom: 2px solid #293495;
  padding: 5px;
  font-size: 16px;
  background: #fff;
  outline: none; /* Remove default focus outline */
`;

const ExportIconContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
  cursor: pointer;
  color: #28a745; /* Green color for Excel icon */
`;


const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;


  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;

const DatewiseReportPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const dropdownRef = useRef(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [companyName, setCompanyName] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [locationName, setLocationName] = useState('');
  const [passReturn, setPassReturn] = useState('');
  const [visitorReports, setVisitorReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalItems, setTotalItems] = useState(0); // Define totalItems in the state

  const itemsPerPage = 10; // Number of items per page
  const [tableData, setTableData] = useState([]); // Initialize without dummy data
  const [searchQuery, setSearchQuery] = useState('');
  const [showPagination, setShowPagination] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 7;
  const [locations, setLocations] = useState([]);
  const [employees, setEmployees] = useState([]);

  const [formValues, setFormValues] = useState({
    employeeName: '',
    locationName: ''

  }

  );



  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const locationsResponse = await axios.get('/Location');
        setLocations(locationsResponse.data);

        const employeesResponse = await axios.get('/employee');
        setEmployees(employeesResponse.data);

      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };

    fetchDropdownData();
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchVisitorTypeData = async () => {
    try {
      const response = await axios.get('/VisitorDetails/GetVisitorReports');
      setTableData(response.data);
      setOriginalTableData(response.data);
    } catch (error) {
      console.error('Error fetching Visitor Report data:', error);
    }
  };

  useEffect(() => {
    fetchVisitorTypeData();
  }, []);
  const formatDate = (date) => {
    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day}`;
  };
  const formatDateToCustom = (date) => {
    const padZero = (number, length = 2) => String(number).padStart(length, '0');

    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1);
    const day = padZero(date.getDate());
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds());
    const milliseconds = padZero(date.getMilliseconds(), 7); // Pad milliseconds to 7 digits

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
  };

  const [originalTableData, setOriginalTableData] = useState([]);

  const handleSearchData = () => {
    let filtered = [...originalTableData]; // Start with all data

    switch (selectedOption) {
      case 'Date Wise':
        if (fromDate && toDate) {
          const from = new Date(fromDate);
          from.setHours(0, 0, 0, 0); // Normalize fromDate to start of the day

          const to = new Date(toDate);
          to.setHours(23, 59, 59, 999); // Normalize toDate to end of the day

          const formattedFromDate = formatDateToCustom(from);
          const formattedToDate = formatDateToCustom(to);

          filtered = filtered.filter(row => {
            const checkInDate = row.checkInDateTime.split('.')[0];
            const checkOutDate = row.checkOutDateTime ? row.checkOutDateTime.split('.')[0] : null;

            return (checkInDate >= formattedFromDate && checkInDate <= formattedToDate) ||
              (checkOutDate && checkOutDate >= formattedFromDate && checkOutDate <= formattedToDate);
          });
        }
        break;
    }

    setTableData(filtered);
  };

  const filteredData = tableData.filter((row) =>
    row.checkInId?.toString().includes(searchQuery) ||
    row.visitorName && row.visitorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.visitMobile && row.visitMobile.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.nationality && row.nationality.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.visitorCompany && row.visitorCompany.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.employeeName && row.employeeName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.locationName && row.locationName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.checkInDateTime && row.checkInDateTime.toLowerCase().includes(searchQuery.toLowerCase())
  );
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const formatDateTime = (dateTime) => {
    return dateTime.replace('T', ' ');
  };
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  // Function to toggle the export options panel
  const togglePanel = () => {
    setIsPanelOpen((prevState) => !prevState);
  };

  const handleExportOptionClick = (format) => {
    if (format === 'excel') {
      exportToExcel(); // Call the Excel export function
    } else if (format === 'pdf') {
      exportToPDF(); // Call the PDF export function
    }

    // Close the panel after making a selection
    setIsPanelOpen(false);
  };
  const exportToExcel = () => {
    const filteredDataNee = filteredData.map((row) => ({
      VisitorName: row.visitorName,
      VisitorId: row.checkInId,
      VisitorMobile: row.visitorMobile,
      Nationality: row.nationality,
      VisitorCompany: row.visitorCompany,
      HostName: row.employeeName,
      VisitDate: new Date(row.checkInDateTime).toLocaleString(),
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredDataNee);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DateWise Reports');

    // Adjust column widths for better alignment
    worksheet['!cols'] = [
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Mobile
      { wpx: 150 }, // Visitor Mobile
      { wpx: 200 }, // Visitor Company
      { wpx: 150 }, // Employee Name
      { wpx: 150 }, // Location Name
      { wpx: 200 }, // Check-In Date Time
    ];

    XLSX.writeFile(workbook, 'Date_wise_Visitor_Report.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text('DateWise Reports', 14, 16);
    doc.autoTable({
      head: [
        ['Photo', 'Visitor Name', 'Visitor Id', 'Visitor Mobile', 'Nationality', 'Visitor Company', 'Host Name', 'Visit Date']
      ],
      body: filteredData.map((row) => [
        '',
        row.checkInId,
        row.visitorName,
        row.visitorMobile,
        row.nationality,
        row.visitorCompany,
        row.employeeName,
        new Date(row.checkInDateTime).toLocaleString(),
      ]),
      startY: 30,
      theme: 'grid',
      theme: 'grid', didDrawCell: (data) => {
        // Ensure we only process body cells, not header or footers
        if (
          data.section === 'body' &&
          data.column.index === 0 &&
          filteredData[data.row.index]?.visitorPhoto
        ) {
          try {
            // Clean base64 string if it already includes the data URI prefix
            let base64 = filteredData[data.row.index].visitorPhoto;
            base64 = base64.replace(/^data:image\/(png|jpeg);base64,/, '');

            const img = `data:image/png;base64,${base64}`;

            const cellWidth = data.cell.width;
            const cellHeight = data.cell.height;
            const imgSize = Math.min(cellWidth, cellHeight) - 2;
            const xOffset = data.cell.x + (cellWidth - imgSize) / 2;
            const yOffset = data.cell.y + (cellHeight - imgSize) / 2;

            doc.addImage(img, 'PNG', xOffset, yOffset, imgSize, imgSize);
          } catch (err) {
            console.error('Error adding image:', err);
          }
        }
      },
    });
    doc.save('Date_wise_Visitor_Report.pdf');
  };
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };

  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');

  // Sort function
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(tableData, column, direction);
    setTableData(sortedData);
  };

  return (
    <Container>
      <Header>
        <Heading>DateWise Visitor Report</Heading>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SearchBox>
            <SearchIcon size={20} />
            <SearchInput
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </SearchBox>
          <DropdownContainerTwo>
            <ExportIcon onClick={togglePanel} title="Export">
              <FiDownload size={25} />
            </ExportIcon>
            {/* Show the panel with options if isPanelOpen is true */}
            {isPanelOpen && (
              <OptionsPanel>
                <OptionItem onClick={() => handleExportOptionClick('excel')}>Excel</OptionItem>
                <OptionItem onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItem>
              </OptionsPanel>
            )}
          </DropdownContainerTwo>
        </div>

      </Header>
      <Card>
        <DropdownContainer ref={dropdownRef}>
          <Label>Report Type</Label>
          <Dropdown onClick={toggleDropdown}>
            <DropdownText>{selectedOption || 'Date Wise'}</DropdownText>
            <DropdownIcon size={20} />
          </Dropdown>
          {isOpen && (
            <DropdownPanel>
              {['Date Wise'].map((option) => (
                <DropdownOption key={option} onClick={() => handleOptionClick(option)}>
                  {option}
                </DropdownOption>
              ))}
            </DropdownPanel>
          )}
        </DropdownContainer>
        {selectedOption === 'Date Wise' && (
          <DateContainer>
            <DateInputContainer>
              <Label>From Date</Label>
              <StyledDatePicker
                selected={fromDate}
                onChange={(date) => setFromDate(date)}
                dateFormat="dd-MM-yyyy"
                maxDate={new Date()} // Prevent selecting future dates

              />
            </DateInputContainer>
            <DateInputContainer>
              <Label>To Date</Label>
              <StyledDatePicker
                selected={toDate}
                onChange={(date) => setToDate(date)}
                dateFormat="dd-MM-yyyy"
                minDate={fromDate}
                maxDate={new Date()}
              />
            </DateInputContainer>
          </DateContainer>
        )}
        <ButtonGroup>

          <Button onClick={() => {
            setFromDate(null);
            setToDate(null);
            setSelectedOption('');
            setTableData([]);
            setTableData([...originalTableData]);
            fetchVisitorTypeData();
            setCurrentPage(1); // Reset pagination to the first page
            setSearchQuery('');
          }}>Reset</Button>
          <Button onClick={handleSearchData}>Search</Button>
        </ButtonGroup>
      </Card>
      {filteredData.length === 0 && (
        <ZeroStateMessage>No data found.</ZeroStateMessage>
      )}
      {filteredData.length > 0 && (
        <TableContainer>
          <StyledTable>
            <thead>
              <tr>
                <TableHeader colSpan={'8'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>DateWise Report </span>
                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                      {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                    </IconWrapper>
                  </div>
                </TableHeader>

              </tr>
            </thead>
            {isExpanded && (
              <>
                <thead>
                  <tr>
                    <TableHeader>Photo</TableHeader>
                    <TableHeader onClick={() => handleSort('visitorName')}>Visitor Name {sortColumn === 'visitorName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('checkInId')}>Visitor Id {sortColumn === 'checkInId' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('visitorMobile')}>Visitor Mobile{sortColumn === 'visitorMobile' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('nationality')}>Nationality{sortColumn === 'nationality' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('visitorCompany')}>Visitor Company{sortColumn === 'visitorCompany' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('employeeName')}>Host Name{sortColumn === 'employeeName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('checkInDateTime')}>Visit Date{sortColumn === 'checkInDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Circle> {row.visitorPhoto ? (
                          <img
                            src={`data:image/png;base64,${row.visitorPhoto}`}
                            alt="Profile"
                            style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                          />
                        ) : (
                          <ProfileIcon>
                            <User size={15} />
                          </ProfileIcon>
                        )}
                        </Circle>
                      </TableCell>
                      <TableCell>{row.visitorName}</TableCell>
                      <TableCell>{row.checkInId}</TableCell>
                      <TableCell>{row.visitorMobile}</TableCell>
                      <TableCell>{row.nationality}</TableCell>
                      <TableCell>{row.visitorCompany}</TableCell>
                      <TableCell>{row.employeeName}</TableCell>
                      <TableCell>
                        {new Intl.DateTimeFormat('en-CA', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false
                        }).format(new Date(row.checkInDateTime))
                          .replace(',', ' :')}
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </>)}
          </StyledTable>
          {isExpanded && (
            <>
              <PaginationContainer>
                <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                  Previous
                </PaginationButton>

                <DropdownSelect value={currentPage} onChange={handlePageChange}>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Page {i + 1}
                    </option>
                  ))}
                </DropdownSelect>

                <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                  Next
                </PaginationButton>
              </PaginationContainer>
            </>)}
        </TableContainer>
      )}
    </Container>
  );
};

export default DatewiseReportPage;
